import Label from "../../../../../components/label";
import RelatedPortfolioSection from "../ProposalDetails/RelatedPortfolio";
import "./index.scss";

const Samples = ({ proposalData, instrId, projectId }) => {
    return (
        <div
            className={
                [
                    ...proposalData?.portfolioLinks,
                    ...proposalData?.portfolioItems,
                    ...proposalData?.portfolioCourses,
                    ...proposalData?.supportingDocuments,
                ].length > 0
                    ? "freelancerModalComponentWrap relative"
                    : "freelancerModalComponentWrap"
            }
        >
            <Label
                label="Supporting Documents"
                className="font18Black boldFont sectionTitleWrapper"
            />

            <RelatedPortfolioSection
                linksAndVideos={proposalData?.portfolioLinks}
                portfolioItems={proposalData?.portfolioItems}
                relatedCourses={proposalData?.portfolioCourses}
                documents={proposalData?.supportingDocuments}
                instrId={instrId}
                projectId={projectId}
            />
        </div>
    );
};

export default Samples;
